import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pagetransitiontypeoptions"
    }}>{`PageTransitionTypeOptions`}</h1>
    <p>{`The page transition type options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`No page transition applied.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BLINDS_TRANSITION`}</strong>{` = 1886667372`}</p>
      <p parentName="blockquote">{`The Blinds page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOX_TRANSITION`}</strong>{` = 1886667384`}</p>
      <p parentName="blockquote">{`The Blinds page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COMB_TRANSITION`}</strong>{` = 1886667618`}</p>
      <p parentName="blockquote">{`The Comb page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COVER_TRANSITION`}</strong>{` = 1886667638`}</p>
      <p parentName="blockquote">{`The Cover page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DISSOLVE_TRANSITION`}</strong>{` = 1886667891`}</p>
      <p parentName="blockquote">{`The Dissolve page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FADE_TRANSITION`}</strong>{` = 1886668388`}</p>
      <p parentName="blockquote">{`The Fade page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PUSH_TRANSITION`}</strong>{` = 1886670963`}</p>
      <p parentName="blockquote">{`The Push page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SPLIT_TRANSITION`}</strong>{` = 1886671728`}</p>
      <p parentName="blockquote">{`The Split page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNCOVER_TRANSITION`}</strong>{` = 1886672227`}</p>
      <p parentName="blockquote">{`The Uncover page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WIPE_TRANSITION`}</strong>{` = 1886672752`}</p>
      <p parentName="blockquote">{`The Wipe page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ZOOM_IN_TRANSITION`}</strong>{` = 1886673481`}</p>
      <p parentName="blockquote">{`The Zoom In page transition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ZOOM_OUT_TRANSITION`}</strong>{` = 1886673487`}</p>
      <p parentName="blockquote">{`The Zoom Out page transition.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      